import Vue from 'vue';
import feathersClient from '../../feathers-client';

const defaultTemplateMappingPagination = {
	total: 100,
	$skip: 0,
	$limit: 7,
};

const defaultTemplateMappingFilter = {
	$skip: defaultTemplateMappingPagination.$skip,
	$limit: defaultTemplateMappingPagination.$limit,
};

export default {
	namespaced:true,
	state: {
		jobTemplateMappings: [],
		templateMappingFilter: defaultTemplateMappingFilter,
		templateMappingPagination: defaultTemplateMappingPagination,
		careLocations: [],
	},
	getters: {
		templateMappingPage: (state) => {
			const { $limit, $skip } = state.templateMappingPagination;
			return $skip / $limit + 1;
		},
		jobtemplateMappings: (state) => state.jobtemplateMappings,
	},
	mutations: {
		SET_JOB_TEMPLATE_MAPPINGS: (state, jobTemplateMappings) => { state.jobTemplateMappings = jobTemplateMappings; },
		SET_TEMPLATE_MAPPING_FILTER: (state, filter) => { state.templateMappingFilter = { ...state.templateMappingFilter, ...filter }; },
		SET_DEFAULT_TEMPLATE_MAPPING_FILTER: (state, filter) => { state.templateMappingFilter = { ...filter, ...defaultTemplateMappingFilter }; },
		SET_TEMPLATE_MAPPING_PAGINATION: (state, data) => { state.templateMappingPagination = { ...state.templateMappingPagination, ...data }; },
		SET_CARE_LOCATIONS: (state, careLocations) => { state.careLocations = careLocations; },

	},
	actions: {
		getAllJobTemplateMappings: async ({ commit,rootGetters }, filter) => {
			const url = '/api/v3/jobtemplatemappings';
			const results = await feathersClient.service(url).find({
				query:{
					$role:rootGetters.currentUserRole,
					fields:['careSpeciality','jobTitle','careLocation','owner','jobTemplates'],
					...filter
				}
			});
			commit('SET_JOB_TEMPLATE_MAPPINGS', results.data);
			commit('SET_TEMPLATE_MAPPING_PAGINATION', { total: results.total });
			return results.data;
		},
		setTemplateMappingFilter: ({ commit }, filter) => {
			commit('SET_TEMPLATE_MAPPING_FILTER', filter);
		},
		setDefaultTemplateMappingFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_TEMPLATE_MAPPING_FILTER', filter);
		},
		setTemplateMappingPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.templateMappingPagination.$limit;
			commit('SET_TEMPLATE_MAPPING_PAGINATION', { $skip });
			commit('SET_TEMPLATE_MAPPING_FILTER', { $skip });
		},
		searchTemplatesForMapping: async ({rootGetters}, filter) => {
			const url = '/api/v3/jobtemplates'
			const results = await feathersClient.service(url).find({
				query:{
					$role:rootGetters.currentUserRole,
					$paginate:false,
					...filter,
				}
			});
			return results;
		},
		addJobTemplateMapping: async ({rootGetters,context}, data) => {
			const url = '/api/v3/jobtemplatemappings';
			const results = await feathersClient.service(url).create(data,{
				query:{
					$role:rootGetters.currentUserRole
				},
			})
			return results;
		},
		addBulkJobTemplateJobTemplateMappings: async ({rootGetters,context}, data) => {
			const url = 'api/v3/jobtemplatemappingjobtemplates';
			const results = await feathersClient.service(url).create(data,{
				query:{
					$role:rootGetters.currentUserRole,
				}
			})
			return results;
		},
		deleteJobTemplateJobTemplateMapping: async ({ rootGetters }, filter) => {
			const url = '/api/v3/jobtemplatemappingjobtemplates';
			const results = await feathersClient.service(url).remove(null,{
				query:{
					$role:rootGetters.currentUserRole,
					...filter
				}
			})
			return results;
		},
		updateJobTemplateJobTemplateMapping: async ({ rootGetters }, mapping) => {
			const id= mapping.id
			delete mapping.id
			const url = 'api/v3/jobtemplatemappingjobtemplates';
			const results = await feathersClient.service(url).patch(id,mapping,{
				query:{
					$role:rootGetters.currentUserRole
				}
			});
			return results;
		},
		deleteJobTemplateMapping: async ({ rootGetters }, filter) => {
			const url = '/api/v3/jobtemplatemappings';
			const results = await feathersClient.service(url).remove(null,{
				query:{
					$role:rootGetters.currentUserRole,
					_id:filter.mappings
				}
			})
			return results;
		},
		getJobTemplateMappingById: async ({rootGetters}, id) => {
			const results = await feathersClient.service('/api/v3/jobtemplatemappings').get(id,{
				query:{
					$role: rootGetters.currentUserRole,
					fields:['careSpeciality','jobTitle','careLocation','owner','jobTemplates'],
				}
			})
			return results;
		},
		getBandByNumber: async (context, filter) => {
			const results = await feathersClient.service('/api/v3/band-types').find({
				query: {
					$sort: { number: 1 },
					...filter,
					$paginate:false
				},
			});
			return results;
		},
		updateJobTemplateMapping: async ({rootGetters}, mapping) => {
			const id = mapping.id
			delete mapping.id
			const url = '/api/v3/jobtemplatemappings';
			const results = await feathersClient.service(url).patch(id,mapping,{
				query:{
					$role:rootGetters.currentUserRole
				},
			})
			return results;
		},
		loadCareLocations: async ({ commit, rootGetters }) => {
			const url = '/api/v3/care-locations';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, $paginate: false } });
			commit('SET_CARE_LOCATIONS', results);
			return results;
		},
	},
};
